import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import Confirmation from "CommonComponents/confirmation";
import {
  ListGroup,
  ListGroupItem,
  Row,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  Radio,
} from "CommonComponents/bricks";
import {
  formatMassnahme,
  validateMassnahme,
  validateVertrag,
} from "Apis/massnahme-api";
import {
  ANTRAGSTELLERMODUS,
  ANTRAGSTYPEN,
  ASTMODUSKEY,
} from "App/constants";

// setupLookups(schemaTyp)

@store("k_einrichtungLookup", "k_antragstyp", "k_antragstypLookup", "k_vertragsartLookup", "k_pfaartLookup", "user")
export default class AntragAnnehmenPopup extends Component {
  constructor() {
    super();
    this.state = { selektiert: [] };
  }

  componentDidMount() {
    const { AntragstellerModus, massnahmen } = this.props;
    if (AntragstellerModus == ASTMODUSKEY.WerkPrivat) {
      this.setState({ a_katid: ANTRAGSTYPEN.WERKVERTRAG });
    } else if (AntragstellerModus == ASTMODUSKEY.Vortrag && massnahmen.length == 1) {
      this.setState({ a_katid: massnahmen[0].m_katid });
    }
  }

  render() {
    const { onClose, massnahmen, AntragstellerModus } = this.props;
    const { errorMessage, fak_eid, a_katid } = this.state;

    const werkvertrag = AntragstellerModus == ASTMODUSKEY.WerkPrivat;
    const lehrvertrag = AntragstellerModus == ASTMODUSKEY.Lehrauftrag;
    const hkvertrag = AntragstellerModus == ASTMODUSKEY.Hilfskraft;
    const vortragvertrag = AntragstellerModus == ASTMODUSKEY.Vortrag;
    const modus = ANTRAGSTELLERMODUS[AntragstellerModus];

    const schemaTyp = {
      table: [{
        field: "a_katid",
        display: this.props.AntragstellerModus == ASTMODUSKEY.Lehrauftrag ? "Antragstyp" : "Vertragstyp",
        type: "select",
        inject: ["k_antragstyp"],
      }],
    };

    schemaTyp.table[0].choices = lookup => () => _.uniqBy(_.map(
      _.filter(lookup, l => modus.vertragsarten.indexOf(l.art_id) >= 0 &&
        !(l.kat_id === ANTRAGSTYPEN.WIEDERHOLUNGSANTRAG && hkvertrag)),
      x => ({ value: x.kat_id, label: x.kat_kbez }),
    ), choice => choice.value);

    const cg = id => {
      const setValue = (schema, value) => {
        this.setState({ [schema.field]: value });
      };
      return <Row style={{ verticalAlign: "middle" }}>{ControlGenerators.select({
        entity: this.state,
        leftCol: 2,
        rightCol: 10,
        schema: schemaTyp.table[id],
        onChange: setValue,
        injects: this.props,
      })}</Row>;
    };

    return (
      <Confirmation
        header='Antrag stellen'
        action='Antrag stellen'
        actionStyle='primary'
        onCancel={onClose}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
      >

        {massnahmen.length > 1 && <p>Bitte wählen Sie aus, zu welcher der relevanten Maßnahmen Sie einen Antrag stellen möchten</p>}
        {massnahmen.length == 1 && <p>Bitte bestätigen Sie, dass Sie zu der folgenden Maßnahmen einen Antrag stellen möchten</p>}

        <br />

        <ListGroup>
          {massnahmen.length > 1 &&
            _.map(massnahmen, (massnahme, i) => (_.isEmpty(fak_eid) || massnahme.m_fakultaet_eid == fak_eid)
                && (!lehrvertrag || _.isEmpty(a_katid) || massnahme.m_katid == a_katid) ?
                <ListGroupItem key={i}>
                  <Radio label={formatMassnahme(massnahme, this.props)} name='massnahmen' data-message={massnahme.m_id} onChange={this.onChange} />
                </ListGroupItem>
: null)}
          {massnahmen.length == 1 &&
            _.map(massnahmen, (massnahme, i) => <ListGroupItem key={i}>{formatMassnahme(massnahme, this.props)}</ListGroupItem>)}
        </ListGroup>

        <div className='box-panel'>
          <div className='detail-form' style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            <form className='form-horizontal'>
              {!werkvertrag && !vortragvertrag && cg(0)}
            </form>
          </div></div>

      </Confirmation>
    );
  }

  onChange = e => {
    const { AntragstellerModus, massnahmen } = this.props;
    const { fak_eid } = this.state;
    let { a_katid } = this.state;
    const id = e.target.getAttribute("data-message");

    if (AntragstellerModus == ASTMODUSKEY.Vortrag) {
      const massnahme = _.find(massnahmen, m => m.m_id == id);
      a_katid = massnahme && massnahme.m_katid;
    }

    /*
     *const werkvertrag = AntragstellerModus == ASTMODUSKEY.WerkPrivat;
     *const lehrvertrag = AntragstellerModus == ASTMODUSKEY.Lehrauftrag;
     *const tarifvertrag = AntragstellerModus == ASTMODUSKEY.Tarif;
     *
     *
     *if (!werkvertrag && !tarifvertrag) {
     *  let { checked } = e.target;
     *  let idx = selektiert.indexOf(id)
     *  if (checked && idx < 0) {
     *    selektiert.push(id);
     *
     *    if (_.isEmpty(fak_eid)) {
     *      // Filter für Fakultät setzen
     *      fak_eid = massnahmen.find(m => m.m_id == id).m_fakultaet_eid
     *    }
     *
     *    if (lehrvertrag && _.isEmpty(a_katid)) {
     *      // Filter für Antragstyp setzen
     *      a_katid = massnahmen.find(m => m.m_id == id).m_katid
     *    }
     *  } else if (!checked && idx >= 0) {
     *    selektiert.splice(idx, 1)
     *    if (selektiert.length == 0) {
     *      // Keiner mehr selektiert, Fakultätsfilter und Antragstypfilter für Lehraufträge löschen
     *      fak_eid = null;
     *
     *      if (lehrvertrag) {
     *        a_katid = null;
     *      }
     *    }
     *  }
     *} else {
     */
    const selektiert = [id];
    // }

    this.setState({ selektiert, fak_eid, a_katid });
  };

  onConfirm = async() => {
    const { selektiert, a_katid } = this.state;
    const { massnahmen, user } = this.props;

    const werkvertrag = this.props.AntragstellerModus == ASTMODUSKEY.WerkPrivat;
    const lehrvertrag = this.props.AntragstellerModus == ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = this.props.AntragstellerModus == ASTMODUSKEY.Tarif;
    const vortragvertrag = this.props.AntragstellerModus == ASTMODUSKEY.Vortrag;

    if (massnahmen.length == 1) {
      selektiert.push(massnahmen[0].m_id);
    } else {
      // Mehr als ein Eintrag
      if (_.isEmpty(selektiert)) {
        this.setState({ errorMessage: "Bitte wählen Sie mindestens eine Maßnahme durch Ankreuzen aus" });
        return false;
      }
    }

    if (!vortragvertrag && _.isEmpty(a_katid)) {
      this.setState({ errorMessage: `Bitte wählen Sie einen ${ this.props.AntragstellerModus == ASTMODUSKEY.Lehrauftrag ? "Antragstyp" : "Vertragstyp" } aus` });
      return false;
    }

    const selektiertemaßnahmen = [];
    _.map(_.filter(massnahmen, m => selektiert.indexOf(m.m_id) >= 0), m => {
      selektiertemaßnahmen.push(m);
    });

    const statusValidate = [];
    _.map(_.filter(massnahmen, m => selektiert.indexOf(m.m_id) >= 0), (m, index) => {
      const status = validateMassnahme(user, m, null);
      if (status) {
        status.nachricht = `Maßnahme ${ index + 1 }: ${ status.nachricht }`;
        statusValidate.push(status);
      }
    });
    if (!_.isEmpty(statusValidate)) {
      this.setState({ errorMessage: statusValidate[0].nachricht });
      return false;
    }

    if (!werkvertrag && !lehrvertrag && !tarifvertrag && !vortragvertrag) {
      // Vertragsarten aller selektierten Maßnahmen prüfen (bei Hilfskraftverträgen)
      const statusArten = [];
      const result = await validateVertrag(_.filter(massnahmen, m => selektiert.indexOf(m.m_id) >= 0), this.state, this.props); // Props wg. Lookups übergeben
      _.map(result, record => {
        statusArten.push({ nachricht: `${ record.index ? `Maßnahme ${ record.index + 1 }:` : "" } ${ record.text }` });
      });
      if (!_.isEmpty(statusArten)) {
        this.setState({ errorMessage: statusArten[0].nachricht });
        return false;
      }
    }

    try {
      const result = await apifetch("/api/shkantrag/massnahmevorgesehen/annehmen", {
        method: "POST",
        body: { massnahme: selektiert[0], a_katid: a_katid },
      });
      this.props.onAngenommen(result.a_id);
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}

